<template>
  <div class="incident-report-listing">
    <v-layout class="my-2">
      <v-flex md12>
        <div class="d-flex">
          <div class="row">
            <template>
              <v-text-field
                v-model.trim="search"
                style="max-width: 400px"
                v-on:click:clear="clearFilter('search')"
                clearable
                dense
                filled
                flat
                placeholder="Search Customer"
                hide-details
                solo
                :loading="dataLoading"
                :disabled="dataLoading"
                color="cyan"
                @keydown.enter="getIncidents()"
                @keydown.tab="getIncidents()"
              ></v-text-field>
            </template>

            <v-select
              v-model="filter_type"
              :items="typeOptions"
              dense
              filled
              flat
              hide-details
              solo
              class="ml-2 mr-2"
              style="max-width: 250px"
              placeholder="Type"
              clearable
              @change="getIncidents()"
              v-on:click:clear="clearFilter('type')"
            >
              <template v-slot:selection="{ item }">
                <v-list-item-action class="ma-0">
                  <v-chip
                    style="height: 10px; width: 10px; padding: 0"
                    :color="item.color"
                  ></v-chip>
                </v-list-item-action>
                <v-list-item-content class="py-0">
                  <v-list-item-title
                    class="text-capitalize font-weight-500 font-size-16"
                  >
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-action class="mr-0">
                  <v-chip
                    style="height: 16px; width: 16px; padding: 0"
                    :color="item.color"
                  ></v-chip>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-capitalize font-weight-500 font-size-16"
                  >
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>

            <DateRangePicker
              placeholder="Date Range"
              v-model="dates"
              v-on:update:model-value="getIncidents()"
              style="max-width: 250px"
              v-on:click:clear="clearFilter('dates')"
            ></DateRangePicker>

            <v-btn
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              tile
              depressed
              :disabled="dataLoading"
              v-on:click="getIncidents()"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            <v-btn
              class="mx-2 custom-bold-button white--text"
              depressed
              :disabled="dataLoading"
              v-on:click="clearAllFilters"
              color="cyan white--text"
            >
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </div>
        </div>
      </v-flex>
      <!-- <v-flex class="text-right">
        <v-btn
          v-on:click="add_incident_dialog = true"
          color="cyan text-white"
          class="ml-2"
          depressed
          tile
        >
          <v-icon small left>mdi-plus</v-icon>Add
          Incident
        </v-btn>
      </v-flex> -->
    </v-layout>

    <ListingTable :columnCount="11" :rowData="incidents">
      <template v-slot:thead>
        <thead>
          <tr>
            <th class="simple-table-th">Type</th>
            <th
              class="simple-table-th"
              style="max-width: 70px; white-space: pre-wrap"
            >
              Show in App
            </th>
            <th class="simple-table-th">Date</th>
            <th class="simple-table-th">Amount Damage</th>
            <th class="simple-table-th" style="white-space: pre-wrap">
              Customer Display name
            </th>
            <th class="simple-table-th">Customer Info</th>
            <th class="simple-table-th">Remark</th>
            <th class="simple-table-th">Tags</th>
            <th class="simple-table-th">Rating</th>
            <th class="simple-table-th">Attachments</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="incidents.length">
            <template v-if="dataLoading == false">
              <tr
                v-for="(row, index) in incidents"
                :key="index"
                class="alternate-listing-row"
              >
                <td class="simple-table-td">
                  <div>
                    <v-chip
                      label
                      :color="row?.type === 'positive' ? 'green' : 'red'"
                      text-color="white"
                      class="ml-2 p-3 text-uppercase font-weight-600"
                      small
                    >
                      {{ row?.type.toUpperCase() }}
                    </v-chip>
                  </div>
                </td>

                <td class="simple-table-td">
                  <v-chip
                    :color="row.show_on_mobile ? 'green' : 'red'"
                    class="ml-3"
                    outlined
                    label
                    small
                  >
                    {{ row.show_on_mobile ? "YES" : "NO" }}
                  </v-chip>
                </td>
                <td>
                  <p class="m-0 custom-nowrap-ellipsis font-weight-700">
                    <template v-if="row.incident_date">{{
                      formatDate(row.incident_date)
                    }}</template>
                    <template v-else
                      ><em class="text--secondary">No Date</em></template
                    >
                  </p>
                </td>

                <td class="simple-table-td">
                  <span class="font-weight-700">
                    {{ $accountingJS.formatMoney(row.amount_damage) }}</span
                  >
                </td>

                <td class="simple-table-td">
                  <span
                    class="d-flex"
                    v-on:click="routeToCustomer(row.customer.id)"
                  >
                    <Barcode :barcode="row.customer.barcode" />
                  </span>
                  <span
                    class="d-flex font-weight-500"
                    v-if="row.customer && !lodash.isEmpty(row.customer)"
                  >
                    {{ row.customer.display_name }}</span
                  >
                  <em v-else class="text-muted text-lowercase"
                    >No Customer Found</em
                  >
                </td>
                <td
                  class="simple-table-td"
                  v-if="
                    row.customer && !lodash.isEmpty(row.customer.company_type)
                  "
                >
                  <template v-if="row.customer.company_type == 'company'">
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b><v-icon class="me-1" small>mdi-email</v-icon></b>
                      <template
                        v-if="
                          row.customer &&
                          !lodash.isEmpty(row.customer.company_email)
                        "
                      >
                        {{ row.customer.company_email }}
                      </template>
                      <em v-else class="text-muted"> no company email</em>
                    </p>
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b><v-icon class="me-1" small>mdi-phone</v-icon></b>
                      <template
                        v-if="
                          row.customer &&
                          !lodash.isEmpty(row.customer.company_number)
                        "
                      >
                        {{ row.customer.company_number }}
                      </template>
                      <em v-else class="text-muted"> no company number</em>
                    </p>
                  </template>

                  <template v-else>
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b><v-icon class="me-1" small>mdi-email</v-icon></b>
                      <template
                        v-if="
                          row.customer &&
                          !lodash.isEmpty(row.customer.default_person)
                        "
                      >
                        {{ row.customer.default_person.primary_email }}
                      </template>
                      <em v-else class="text-muted"> no company email</em>
                    </p>
                    <p class="m-0 custom-nowrap-ellipsis">
                      <b><v-icon class="me-1" small>mdi-phone</v-icon></b>
                      <template
                        v-if="
                          row.customer &&
                          !lodash.isEmpty(row.customer.default_person)
                        "
                      >
                        {{ row.customer.default_person.primary_phone }}
                      </template>
                      <em v-else class="text-muted"> no company number</em>
                    </p>
                  </template>
                </td>
                <td class="simple-table-td">
                  <read-more
                    class="mx-4 custom-read-more font-weight-600 font-size-18 pb-1"
                    more-str="read more"
                    :text="
                      row.remark || '<em class=\'text-muted\'>No Remarks</em>'
                    "
                    link="#"
                    less-str="read less"
                    :max-chars="120"
                  >
                  </read-more>
                </td>
                <td class="simple-table-td">
                  <template v-if="row.tags && row.tags.length">
                    <template v-for="(data, index) in row.tags">
                      <v-chip
                        :key="index"
                        v-if="index < 2"
                        style="height: 18px"
                        class="mr-2 mb-1"
                        text-color="white"
                        :color="data.color"
                        >{{ data.text }}</v-chip
                      >
                    </template>
                    <template v-if="row.tags.length > 2">
                      <v-chip small color="blue white--text" label class="ml-2">
                        <span class="font-size-16 font-weight-500">
                          +{{ row.tags.length - 2 }} More</span
                        >
                      </v-chip>
                    </template>
                  </template>
                  <em v-else class="text-muted"> no tags</em>
                </td>

                <td class="simple-table-td">
                  <div class="d-flex align-center">
                    <v-rating
                      :value="1"
                      background-color="orange lighten-3"
                      style="font-size: 30px; margin: 0px 0px 0px 8px"
                      color="orange"
                      readonly
                      class="mb-1"
                      dense
                      :length="1"
                    />
                    <div style="font-size: 19px" class="ml-1">
                      {{ Number(row.rating) }}
                    </div>
                  </div>
                </td>

                <td v-if="false">
                  <div style="width: 10%" class="px-4 d-flex align-center">
                    <v-spacer></v-spacer>

                    <v-btn
                      v-on:click="doAction(row, 'delete')"
                      icon
                      small
                      depressed
                      class="mx-1"
                      color="red lighten-1"
                      ><v-icon medium>mdi-delete</v-icon></v-btn
                    >
                  </div>
                </td>
                <td class="simple-table-td">
                  <div class="d-flex align-center">
                    <template
                      v-if="row?.attachments && row.attachments?.length > 0"
                    >
                      <div
                        class="attachment-preview"
                        @click="downloadAttachment(row.attachments[0])"
                      >
                        <template v-if="isImage(row.attachments[0].extension)">
                          <ImageTemplate
                            :src="row.attachments[0].file.url"
                            style="max-width: 50px; width: 50px"
                          />

                          <v-tooltip top content-class="custom-top-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 d-inline-table font-weight-600"
                                color="chip-custom-blue"
                                label
                                outlined
                                small
                              >
                                <!-- <v-icon left small>mdi-image</v-icon> -->
                                <!-- {{ row.attachments[0].name }} -->
                              </v-chip>
                            </template>
                            <span class="tooltip-content">
                              <div class="mb-1">
                                <b> {{ row.attachments[0].name }}</b>
                              </div>
                            </span>
                          </v-tooltip>
                        </template>

                        <template v-else>
                          <inline-svg
                            style="max-width: 50px; width: 50px"
                            :src="
                              $assetURL(
                                `media/mime/${row.attachments[0].extension}.svg`
                              )
                            "
                          />
                          <v-tooltip top content-class="custom-top-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                              <v-chip
                                v-bind="attrs"
                                v-on="on"
                                class="mx-2 d-inline-table font-weight-600"
                                color="chip-custom-blue"
                                label
                                outlined
                                small
                              >
                                <!-- <v-icon left small>mdi-file</v-icon> -->
                                <!-- {{ row.attachments[0].name }} -->
                              </v-chip>
                            </template>
                            <span class="tooltip-content">
                              <div class="mb-1" v-if="false">
                                <b> {{ row.attachments[0].name }}</b>
                              </div>
                            </span>
                          </v-tooltip>
                        </template>
                      </div>
                      <v-chip
                        v-if="row.attachments.length > 1"
                        small
                        class="ml-2 cyan white--text"
                        @click="showAttachments(row.attachments)"
                      >
                        +{{ row.attachments.length - 1 }} more
                      </v-chip>
                    </template>
                    <em v-else class="text-muted">No attachments</em>
                  </div>
                </td>
              </tr>
            </template>
          </template>

          <template v-else>
            <template v-if="dataLoading">
              <tr v-for="rcount in 10" :key="rcount">
                <td class="px-2 py-2" v-for="dcount in 10" :key="dcount">
                  <v-skeleton-loader class="custom-skeleton" type="text">
                  </v-skeleton-loader>
                </td>
              </tr>
            </template>
            <template v-if="dataLoading == false">
              <tr>
                <td colspan="7">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    No incident reports found.
                  </p>
                </td>
              </tr>
            </template>
          </template>
        </tbody>

        <AttachmentListModal
          :show="attachmentDialog"
          :attachments="selectedAttachments"
          v-on:close="attachmentDialog = false"
          @download="downloadAttachment"
        />
      </template>
    </ListingTable>

    <ListingFooter
      :dataLoading="dataLoading"
      :showingFrom="showingFrom"
      :showingTo="showingTo"
      :totalRows="totalRows"
      :currentPage="currentPage"
      :totalPages="totalPages"
    ></ListingFooter>
    <!-- <InternalIncidentReport
      :document-dialog="add_incident_dialog"
      :type-id="typeId"
      @close="closeDialog"
      @success="handleIncident" -->
  </div>
</template>

<script>
// import InternalIncidentReport from "@/view/pages/engineer/create-or-update/Internal-Incident-Report";
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import DateRangePicker from "@/view/components/DateRangePicker";
import ImageTemplate from "@/view/pages/Image";
import AttachmentListModal from "@/view/components/AttachmentListModal";
import Barcode from "@/view/pages/partials/Barcode.vue";
import moment from "moment";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
export default {
  name: "IncidentReport",
  mixins: [CommonMixin],
  props: {
    type: {
      type: Number,
      default: 0,
    },
    typeId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    // Dialog,
    Barcode,
    ListingTable,
    DateRangePicker,
    ListingFooter,
    ImageTemplate,
    AttachmentListModal,
    // InternalIncidentReport,
  },
  data() {
    return {
      incidents: [],
      attachmentDialog: false,
      selectedAttachments: [],
      // add_incident_dialog: false,

      isUpdate: false,
      editData: null,
      selectedId: null,

      rowData: [],
      dataLoading: false,

      status: "",
      filter_report: "",
      customer: "",
      extensionArray: ["jpg", "png", "gif", "jpeg", "webp", "tiff", "jfif"],

      filter_type: null,
      typeOptions: [
        { text: "Positive", value: "positive", color: "green" },
        { text: "Negative", value: "negative", color: "red" },
      ],
      dates: [],
      search: "",
      currentPage: 1,
      totalPages: 1,

      totalRows: 0,
      rowsOffset: 0,
    };
  },
  methods: {
    getIncidents() {
      const data = {
        current_page: this.currentPage,
        per_page: 15,
        entity: 0,
        technician: this.typeId,
        search: this.search,
        type: this.filter_type,
        dates: this.dates ? this.dates : [],
      };

      if (this.dataLoading) {
        return false;
      }

      if (this.dates && this.dates.length === 2) {
        if (this.lodash.isEmpty(this.dates) === false) {
          if (moment(this.dates[0]).isAfter(this.dates[1])) {
            this.showError("End Date must be after Start Date.");
            return false;
          }
        }
      }

      this.dataLoading = true;

      this.$store
        .dispatch(QUERY, { url: "technician/incident", data: data })
        .then(({ data }) => {
          this.incidents = data.rows;
          this.totalPages = Math.ceil(data.total_rows / data.per_page);
          this.currentPage = Number(data.current_page);
          this.totalRows = Number(data.total_rows);
          this.rowsOffset = Number(data.offset);
        })
        .catch((error) => {
          this.dataLoading = false;
          this.logError(error);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    routeToCustomer(id) {
      this.$router.push({
        name: "admin.customer.detail",
        params: { id },
      });
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.getIncidents();
    },
    // handleIncident() {
    //   this.$emit("success", true);
    //   this.getIncidents();
    // },

    clearFilter(field) {
      switch (field) {
        case "search":
          this.search = null;
          break;
        case "type":
          this.filter_type = null;
          break;
        case "dates":
          this.dates = [];
          break;
      }
      this.getIncidents();
    },

    clearAllFilters() {
      this.search = null;
      this.filter_type = null;
      this.dates = [];
      this.currentPage = 1;
      this.getIncidents();
    },

    doAction(row, param) {
      switch (param) {
        case "delete":
          this.id = row.id;
          this.deleteDialog = true;
          break;
      }
    },

    showAttachments(attachments) {
      this.selectedAttachments = attachments;
      this.attachmentDialog = true;
    },

    isImage(ext) {
      if (find(this.extensionArray, (row) => row == ext.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    formatFileSize(bytes) {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    downloadAttachment(attachment) {
      window.open(attachment.file.url, "_blank");
    },
  },
  mounted() {
    this.getIncidents();
    PaginationEventBus.$on("update:pagination", (param) => {
      this.currentPage = param;
      this.getIncidents();
    });
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.incidents) === false
        ? this.rowsOffset + 1
        : 0;
    },
    showingTo() {
      return this.rowsOffset + (this.incidents ? this.incidents.length : 0);
    },
  },
};
</script>

<style>
.attachment-preview {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.attachment-preview:hover {
  opacity: 0.8;
}
</style>
